import React from 'react';

import RecordsScreen from '/component/layout/RecordsScreen';
import {COACH_REPORT} from '/enum/popover.enum';
import {REPORT_CARD_CONTENT_ALL_COACHES} from '/enum/reportCard.enum';
import {withTranslation} from '/provider/TranslationProvider';
import {withHOC} from '/util/hoc.util';

import {ReportProps} from '../Report.types';
import withRecordPopover from '../withRecordPopover';

import {FrontlineCoachesContent} from './FrontlineCoachesContent';
import reportPayload from './reportPayload';

export const FrontlineCoachesReport = ({
  loadingData = {total: 0},
  tt = (key: string, defaultValue?: string) => defaultValue || '',
  showRecordPopover = () => {},
}: ReportProps) => {
  return (
    <RecordsScreen
      {...reportPayload}
      title={tt('title', 'Frontline Coaches')}
      description={tt(
        'description',
        'Shows Frontline Coaches in this monthly period and how they are performing.',
      )}
      contentProps={{loadingData, showRecordPopover}}
      contentComponent={FrontlineCoachesContent}
    />
  );
};

export default withHOC(
  withTranslation('report.frontlineCoaches'),
  withRecordPopover({
    reportPayload,
    popoverName: COACH_REPORT,
    popoverContentName: REPORT_CARD_CONTENT_ALL_COACHES,
    popoverContentProps: {
      renderTitle: () =>
        withTranslation.ts('reportRecordTitle.frontLine', 'Frontline Coaches'),
    },
  }),
)(FrontlineCoachesReport);
